var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-187.658%",
    cy: "142.624%",
    fx: "-187.658%",
    fy: "142.624%",
    r: "597.666%",
    gradientTransform: "matrix(.57732 0 0 1 -.793 0)",
    id: "g7wwdo6aaa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23DBD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9BA8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "325.173%",
    cy: "-223.961%",
    fx: "325.173%",
    fy: "-223.961%",
    r: "638.254%",
    gradientTransform: "matrix(1 0 0 .57737 0 -.947)",
    id: "pq6qrxlc0b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23DBD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9BA8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "82.099%",
    cy: "-25.968%",
    fx: "82.099%",
    fy: "-25.968%",
    r: "926.883%",
    gradientTransform: "matrix(.57732 0 0 1 .347 0)",
    id: "qzinshrpvc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23DBD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9BA8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "98.808%",
    cy: "-71.487%",
    fx: "98.808%",
    fy: "-71.487%",
    r: "660.925%",
    gradientTransform: "matrix(1 0 0 .5773 0 -.302)",
    id: "8gd1c3qsnd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23DBD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9BA8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "125.406%",
    cy: "-95.251%",
    fx: "125.406%",
    fy: "-95.251%",
    r: "1236.785%",
    gradientTransform: "matrix(1 0 0 .57737 0 -.403)",
    id: "i1c2ydymoe"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23DBD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9BA8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "244.031%",
    cy: "-208.169%",
    fx: "244.031%",
    fy: "-208.169%",
    r: "1216.023%",
    gradientTransform: "matrix(.57732 0 0 1 1.031 0)",
    id: "apaue5xhaf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23DBD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9BA8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "401.747%",
    cy: "-191.781%",
    fx: "401.747%",
    fy: "-191.781%",
    r: "816.033%",
    gradientTransform: "matrix(1 0 0 .57737 0 -.81)",
    id: "pn6pqraw1g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23DBD4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9BA8",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g7wwdo6aaa)",
    d: "m8.9 10.278 8.899 5.138-8.9 5.138L0 15.416z",
    transform: "translate(17.2 11.921)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pq6qrxlc0b)",
    d: "M8.9 10.277V0l8.9 5.138v10.278z",
    transform: "translate(17.2 11.921)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qzinshrpvc)",
    d: "m8.9 0 8.9 5.138-8.9 5.138L0 5.138z",
    transform: "translate(4.45 4.57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#8gd1c3qsnd)",
    d: "M8.9 20.554V10.276l8.9-5.138v10.277z",
    transform: "translate(4.45 4.57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i1c2ydymoe)",
    d: "M0 15.415V5.138l8.9 5.138v10.278z",
    transform: "translate(4.45 4.57)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#apaue5xhaf)",
    d: "m8.9 0 8.9 5.138-8.9 5.138L0 5.138z",
    transform: "translate(0 2.001)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pn6pqraw1g)",
    d: "M0 15.415V5.138l8.9 5.138v10.278z",
    transform: "translate(0 2.001)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#FBFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.901 2 8.9 5.138-8.9 5.138-8.9-5.138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.415.003 7.138l8.9 5.138L8.9 22.554z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.54575923.svg";
export { ForwardRef as ReactComponent };